import styled from 'styled-components';

import { getPurpurSpacing } from '@telialt/common-theme/src/purpurSelectors';

export const NoNboOffersWrapper = styled.div`
    margin: ${getPurpurSpacing('800')} auto 0;
    max-width: 45rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    gap: ${getPurpurSpacing('200')};
`;
